import { Field, useFormikContext } from 'formik';
import React from 'react';
import { AutoCompleteSelectUI, DatePickerUI, FormErrorUI, FormLabelUI, InputUI } from '../../Interface';

const ComplaintReportD8 = ({ disabled, autoCompleteOptions, selectedValues }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div>
      <Field
        type="text"
        name="projectCompleted"
        as={InputUI}
        className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
        fullWidth
        label={<FormLabelUI text="8D projekt befejezve" />}
        variant="standard"
        helperText={<FormErrorUI message={errors.projectCompleted} />}
        disabled={disabled}
        InputLabelProps={{ shrink: values.projectCompleted && values.projectCompleted !== '' }}
        multiline
        rows={8}
      />
      <div className="grid grid-cols-12 gap-x-4">
        <div className="col-span-12 md:col-span-6">
          <Field
            type="autocomplete"
            name="resourceOneId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Név" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.resourceOneId} />}
            onChange={(_e, newVal) => {
              setFieldValue('resourceOneId', newVal?.value ?? null).then(() => {
                validateField('resourceOneId');
              });
            }}
            disabled={disabled}
            InputLabelProps={{ shrink: values.resourceOneId !== '' }}
            selectedValue={values.resourceOneId}
            selectedLabelValue={selectedValues?.resourceOne?.name}
            dataset={autoCompleteOptions?.employee}
          />
        </div>
        <div className="col-span-12 md:col-span-6">
          <Field
            type="date"
            name="projectStatusDate"
            component={DatePickerUI}
            value={values.projectStatusDate}
            fullWidth
            label={<FormLabelUI text="Dátum" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.projectStatusDate} />}
            onChange={(date) => {
              setFieldValue('projectStatusDate', date).then(() => {
                validateField('projectStatusDate');
              });
            }}
            disabled={disabled}
            InputLabelProps={{ shrink: values.projectStatusDate !== '' }}
          />
        </div>
      </div>
    </div>
  );
};

export default ComplaintReportD8;
